var render = function (_h,_vm) {var _c=_vm._c;return _c('div',{staticClass:"c-async-loading"},[_c('v-progress-circular',{attrs:{"indeterminate":"","color":"grey"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }